/**
 * Aviso de versión nueva disponible.
 *
 * ──────────────────────────────────────────────────────────────────────────
 * POR QUÉ ESTO EXISTE Y POR QUÉ NO SE ACTUALIZA SOLO
 * ──────────────────────────────────────────────────────────────────────────
 *
 * El service worker está en `registerType: 'prompt'`: no aplica la versión
 * nueva por su cuenta porque recargar a media entrevista le costaría al
 * encuestador rehacer la lectura delante del entrevistado.
 *
 * Pero durante un tiempo la configuración dijo `prompt` y ESTE AVISO NO
 * EXISTÍA, así que no había forma de aceptar nada: la aplicación se quedaba
 * congelada en la primera versión que cacheó, indefinidamente. Los teléfonos
 * en campo nunca habrían recibido una corrección.
 *
 * El aviso se muestra SÓLO fuera de la entrevista —en el inicio—, que es
 * justo «entre viviendas», el momento que el comentario original describía.
 */

import { useRegisterSW } from 'virtual:pwa-register/react';

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Buscar versión nueva cada 30 min. Sin esto, el navegador sólo
      // comprueba al cargar la página, y la PWA instalada puede pasar días
      // sin cerrarse.
      if (registration) {
        setInterval(() => void registration.update(), 30 * 60 * 1000);
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="notice notice--info" role="status">
      <span className="notice__title">Hay una versión nueva</span>
      Aplícala antes de empezar la siguiente vivienda. La aplicación se recarga y lo que tengas
      capturado se conserva.
      <div className="row" style={{ marginTop: 12 }}>
        <button
          type="button"
          className="btn btn--primary btn--sm"
          onClick={() => void updateServiceWorker(true)}
        >
          Actualizar ahora
        </button>
      </div>
    </div>
  );
}
